import { Stack, Typography } from '@mui/material';
import SmsIcon from '@mui/icons-material/SmsOutlined';
import EmailIcon from '@mui/icons-material/EmailOutlined';
import MarketingCreditsItem from './MarketingCreditsItem';
import useGetMarketingData from '../../../hooks/marketing/useGetMarketingData';
import {
  calculateCreditsUsage,
  getAccessLevel,
} from '../../../helpers/marketing';
import useUser from '../../../hooks/global/useUser';
import useGetEmployeeCredits from '../../../hooks/marketing/useGetEmployeeCredits';

function MarketingCredits() {
  const { user } = useUser();
  const { data: marketingData, isLoading: isLoadingMarketingData } =
    useGetMarketingData();

  const accessLevel = getAccessLevel(user);

  const { data: employeeCredits, isLoading: isLoadingEmployeeCredits } =
    useGetEmployeeCredits();

  const { remaining, surplus } = calculateCreditsUsage({
    marketingData,
    user,
    employeeCredits,
  });

  const isLoading = isLoadingMarketingData || isLoadingEmployeeCredits;

  return (
    <Stack gap={0.5}>
      <Typography variant="overline" component="p">
        {accessLevel === 'full' ? 'Free Monthly Credits Remaining' : 'Credits'}
      </Typography>
      <Stack direction="row" gap={1} flexWrap="wrap">
        {accessLevel === 'full' ? (
          <>
            <MarketingCreditsItem
              type="monthly"
              remaining={remaining.sms}
              total={marketingData?.monthlySmsCredits || 0}
              icon={SmsIcon}
              label="SMS"
              surplus={surplus.sms}
              isLoading={isLoading}
            />
            <MarketingCreditsItem
              type="monthly"
              remaining={remaining.email}
              total={marketingData?.monthlyEmailCredits || 0}
              icon={EmailIcon}
              label="email"
              surplus={surplus.email}
              isLoading={isLoading}
            />
          </>
        ) : (
          <>
            <MarketingCreditsItem
              type="fixed"
              credits={remaining.sms}
              icon={SmsIcon}
              label="SMS"
              isLoading={isLoading}
            />
            <MarketingCreditsItem
              type="fixed"
              credits={remaining.email}
              icon={EmailIcon}
              label="email"
              isLoading={isLoading}
            />
          </>
        )}
      </Stack>
    </Stack>
  );
}

export default MarketingCredits;
